


export type SortObject<T> = {
	property: keyof T,
	mode: SortModeEnum
};


export enum SortModeEnum {
	none = "None",
	asc = "Ascending",
	desc = "Descending"
}